import { AppState, UrlPartSerializer } from '@immosky/types';
import { TypedAction } from '@ngrx/store/src/models';
import { setRoomCountFilterBasedOnUrlValues } from './room-count.actions';

export class RoomCountSerializer implements UrlPartSerializer {
  constructor(public readonly key: string) {}

  deserialize(urlValue: string): TypedAction<string> {
    const values = urlValue.split(',').map((v) => v.trim());

    const min = parseInt(values[0], 10);
    const max = parseInt(values[1], 10);

    return setRoomCountFilterBasedOnUrlValues({
      values: {
        min,
        max,
      },
    });
  }

  serialize(state: AppState): string {
    const roomCountFilter = state.filter.roomCount.filter;
    return `${roomCountFilter.min.value},${roomCountFilter.max.value}`;
  }
}
